import React from "react";
import AuthLayout from "../components/auth/AuthLayout";
import LoginFormContent from "../components/auth/LoginFormContent";

export default function LoginPage() {
  return (
    <AuthLayout>
      <LoginFormContent />
    </AuthLayout>
  );
}
